import { render, staticRenderFns } from "./LogsManager.vue?vue&type=template&id=7389fda4&scoped=true"
import script from "./LogsManager.vue?vue&type=script&lang=ts"
export * from "./LogsManager.vue?vue&type=script&lang=ts"
import style0 from "./LogsManager.vue?vue&type=style&index=0&id=7389fda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7389fda4",
  null
  
)

export default component.exports